document.addEventListener("DOMContentLoaded", function () {
  const trigger = document.querySelector(".ij-mobile-filter-trigger__button");
  const close = document.querySelector(".ij-filter-drawer__close");
  const overlay = document.querySelector(".ij-filter-drawer-overlay");

  function openDrawer() {
    document.body.classList.add("ij-filter-drawer-open");
  }

  function closeDrawer() {
    document.body.classList.remove("ij-filter-drawer-open");
  }

  if (trigger) trigger.addEventListener("click", openDrawer);
  if (close) close.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });
});